import { gql } from '@apollo/client';

export const ADD_ROLE = gql`
  mutation AddRole($input: RoleApiRequestInput!) {
    addRole(input: $input) {
      success
      message
      messageCode
      data {
        id
      }
    }
  }
`;

export interface RoleApiRequestInput {
  id?: number | null;
  name: string;
  description?: string | null;
  packageIds?: number[];
}

export interface AddRoleResponse {
  addRole: {
    success: boolean;
    message: string;
    messageCode?: string | null;
    data?: { id?: number | string | null } | null;
  };
}

export interface AddRoleVariables {
  input: RoleApiRequestInput;
}
